module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QsVDTQfPyGZagAAAMZJREFUWMNjYBgFIx0wUsOQPaKc/4lR5/L6OyNVHUCsxfgcwUgNy7H5jFjARGnwU2L50EmE1IhrshxAjsWkOoKRVpYT6wgmWscxtTxC/0RITZfjiwaaRwGhNDDguWDoAWyh8nNrjeKAOoCSqGIk13JY/FJaKzINdJQyMYyCAU6QTMRahG4wtXIDQQf8Pr34Pz4Lfu3p+M/AwMDw//w2TXIcwkhKMNtvm8XAahrLiG4BJVmSYAggG8RqGsuILobNouFZBwxbAAAvRWNmy3KwewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/acs.png
// module id = WEGN
// module chunks = 0